module.exports = __webpack_public_path__ + "static/media/plane(22).11d18539.PNG";